export default __webpack_public_path__ + "static/media/WebHook.84a75e2e.svg";